<template>
  <div class="card" :class="height100 ? 'h-100' : 'h-auto'">
    <div class="card-header" v-if="!disableTitle">
      <slot name="header">
        <Logo v-if="logo" class="header-image ml-0 mr-2" :logo="logo" :size="30" />
        <div class="header-title">
          {{ title }}
          <LearnMore v-if="help" :help="help" />
        </div>
        <div>
          <slot name="header-right">
            <template v-for="(icon, i) in icons">
              <div :key="i" @click="iconAction(icon)" class="card-header-icon pl-3">
                <Icon :icon="icon.icon" :color="icon.iconColor || 'default'" :alt="icon.name" />
              </div>
            </template>
          </slot>
        </div>
      </slot>
    </div>
    <div class="card-body" :class="{ 'pad-zero': noPad }">
      <slot>{{ content }}</slot>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/display/icon/Icon";
import LearnMore from "@/components/display/LearnMore";
import Logo from "@/components/display/Logo";

export default {
  name: "Card",
  components: {
    Icon,
    LearnMore,
    Logo,
  },
  props: {
    content: String,
    disableTitle: Boolean,
    height100: {
      type: Boolean,
      default: true,
    },
    logo: String,
    title: String,
    noPad: {
      type: Boolean,
      default: false,
    },
    icons: Array,
    help: {
      type: Object,
    },
  },
  setup() {
    const helpAction = (help) => {
      if (help.action) {
        help.action();
      }
    };

    const iconAction = (icon) => {
      if (icon.action) {
        icon.action();
      }
    };

    return {
      helpAction,
      iconAction,
    };
  },
};
</script>

<style lang="scss">
@import "~@/styles/variables";
.card {
  .card-header {
    height: $card-header-height;
    padding: $card-header-padding;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .header-image img {
      height: 30px;
      width: auto;
    }

    .header-title {
      font-size: 1.25rem;
      font-weight: 500;
      line-height: 1rem;
      flex: 1;
    }

    .card-header-icon {
      cursor: pointer;
      display: inline-flex;
    }
  }

  .card-body {
    font-size: 0.875rem;
    &.pad-zero {
      padding: 0;
    }
  }
}
</style>
